export const InviteClassmateActionTypes = {
    OPEN_INVITE_CLASSMATE_PAGE: 'OPEN_INVITE_CLASSMATE_PAGE',
    CLOSE_INVITE_CLASSMATE_PAGE: 'CLOSE_INVITE_CLASSMATE_PAGE',
};